import LanuchWeapp from './src/LaunchWeapp.vue';
import { isInMiniProgram } from './utils/jsapiSupport';


export {
  LanuchWeapp,
  isInMiniProgram,
};
